import React from 'react';
import Home from './Home';
import './App.css';
import SignIn from './SignIn';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';

const Container = styled.div`
  max-width: auto;
  margin: 0 auto;
`;
function initializeReactGA() {
  ReactGA.initialize('UA-171558897-1');
  ReactGA.pageview('/homepage');
}
const history = createBrowserHistory();


function App() {
  initializeReactGA();
  // Initialize google analytics page view tracking
  history.listen(location => {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname); // Record a pageview for the given page
  });
  return (
            
    
       <BrowserRouter history={history}>
        <div>
       
          <Container>
            <Switch>
              <Route
                path="/"
                exact
                component={Home}
              />
              <Route
                path="/ingresoclientes"
                exact
                component={SignIn}
              />
              <Redirect to="/" />
            </Switch>
          </Container>   
        </div>
        </BrowserRouter>
        
  );
}

export default App;
